var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isMobile?'deletedM':'deleted'},[_vm._v("\n  "+_vm._s(_vm.pageData)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }